import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArticleIcon from '@mui/icons-material/Article';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { MenuItem } from 'types/global';

type ShorcutsProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function ReportSync({ selected, onSelect, open }: ShorcutsProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/report"
			selected={selected === MenuItem.ReportSync}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.ReportSync)}
		>
			<ListItemIcon>
				<ArticleIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:reportSync')} />}
		</ListItem>
	);
}
